var keyDescription = null;

var getKeyDescription = function getKeyDescription() {
  return keyDescription || (keyDescription = createKeyDescription());
};

var createKeyDescription = function createKeyDescription() {
  return navigator.platform.includes('Mac') ? {
    name: 'Alt',
    checkPressed: function checkPressed(event) {
      return event.altKey;
    }
  } : {
    name: 'Ctrl',
    checkPressed: function checkPressed(event) {
      return event.ctrlKey;
    }
  };
};

export var getKeyName = function getKeyName() {
  return getKeyDescription().name;
};
export var checkKeyPressed = function checkKeyPressed(event) {
  return getKeyDescription().checkPressed(event);
};